export const elder = {
  'a' : 'ᚨ',
  'b' : 'ᛒ',
  'c' : 'ᚲ',
  'd' : 'ᛞ',
  'e' : 'ᛖ',
  'f' : 'ᚠ',
  'g' : 'ᚷ',
  'h' : 'ᚺ',
  'i' : 'ᛁ',
  'j' : 'ᛃ',
  'k' : 'ᚲ',
  'l' : 'ᛚ',
  'm' : 'ᛗ',
  'n' : 'ᚾ',
  'o' : 'ᛟ',
  'p' : 'ᛈ',
  'q' : 'ᚲ',
  'r' : 'ᚱ',
  's' : 'ᛊ',
  't' : 'ᛏ',
  'u' : 'ᚢ',
  'v' : 'ᚹ',
  'w' : 'ᚹ',
  'x' : 'ᚲᛊ',
  'y' : 'ᛃ',
  'z' : 'ᛉ',
  'ᚦ' : 'ᚦ',
  'ᛜ' : 'ᛜ',
  ' ' : '᛫'
};

export const younger = {
  'a' : 'ᛅ',
  'b' : 'ᛒ',
  'c' : 'ᚴ',
  'd' : 'ᛏ',
  'e' : 'ᛁ',
  'f' : 'ᚠ',
  'g' : 'ᚴ',
  'h' : 'ᚼ',
  'i' : 'ᛁ',
  'j' : 'ᛁ',
  'k' : 'ᚴ',
  'l' : 'ᛚ',
  'm' : 'ᛘ',
  'n' : 'ᚾ',
  'o' : 'ᚢ',
  'p' : 'ᛒ',
  'q' : 'ᚴ',
  'r' : 'ᚱ',
  's' : 'ᛋ',
  't' : 'ᛏ',
  'u' : 'ᚢ',
  'v' : 'ᚢ',
  'w' : 'ᚢ',
  'x' : 'ᚴᛋ',
  'y' : 'ᛁ',
  'z' : 'ᛋ',
  'ᚦ' : 'ᚦ',
  'ᚴ' : 'ᚴ',
  ' ' : '᛫'
};

export const anglo = {
  'a' : 'ᚪ',
  'b' : 'ᛒ',
  'c' : 'ᚳ',
  'd' : 'ᛞ',
  'e' : 'ᛖ',
  'f' : 'ᚠ',
  'g' : 'ᚷ',
  'h' : 'ᚻ',
  'i' : 'ᛁ',
  'j' : 'ᛄ',
  'k' : 'ᛣ',
  'l' : 'ᛚ',
  'm' : 'ᛗ',
  'n' : 'ᚾ',
  'o' : 'ᚩ',
  'p' : 'ᛈ',
  'q' : 'ᚳ',
  'r' : 'ᚱ',
  's' : 'ᛋ',
  't' : 'ᛏ',
  'u' : 'ᚢ',
  'v' : 'ᚹ',
  'w' : 'ᚹ',
  'x' : 'ᛉ',
  'y' : 'ᚣ',
  'z' : 'ᛋ',
  'ᚦ' : 'ᚦ',
  'ᛝ' : 'ᛝ',
  ' ' : '᛫'
};

export const single = '᛫';
export const multiple = '᛬';
export const cross = '᛭';



// WEBPACK FOOTER //
// ./src/constants/RuneMap.js